import { NgModule } from '@angular/core';
import { ZuperUtilsService } from '@zuper/services/utils/utils.service';

@NgModule({
    providers: [
        ZuperUtilsService
    ]
})
export class ZuperUtilsModule
{
    /**
     * Constructor
     */
    constructor(private _zuperUtilsService: ZuperUtilsService)
    {
    }
}
